import { render, staticRenderFns } from "./groupcheck.vue?vue&type=template&id=67be5fd4&scoped=true&"
import script from "./groupcheck.vue?vue&type=script&lang=js&"
export * from "./groupcheck.vue?vue&type=script&lang=js&"
import style0 from "./groupcheck.vue?vue&type=style&index=0&id=67be5fd4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67be5fd4",
  null
  
)

export default component.exports